import React, { useEffect, useState } from 'react'
import { Form, Field } from 'react-final-form'
import { Row, Col, ButtonToolbar, Button } from 'reactstrap'
import { useDispatch, sendFlashMessage } from '@/shared/components/flash'
import ApiErrorMessage from '@/shared/components/ApiErrorMessage'
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'
import Select from 'react-select'
import axios from 'axios'
import { useParams, useHistory } from 'react-router-dom'

const EditBannerStatusPage = ({ organization }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { id } = useParams()
    const [loading, setLoading] = useState(true)
    const [domains, setDomains] = useState([])
    const [initialValues, setInitialValues] = useState(null)

    //Fetch banner status
    useEffect(() => {
        axios
            .get(`/organization/${organization.id}/system/banner-status/${id}`)
            .then(res => {
                setInitialValues(res.data.data)
                setLoading(false)
            })
            .catch(err => {
                dispatch(
                    sendFlashMessage(
                        <ApiErrorMessage errors={err.response?.data} />,
                        'alert-danger'
                    )
                )
                setLoading(false)
            })
    }, [id, organization.id])

    //Fetch domains
    useEffect(() => {
        axios
            .get(`/organization/${organization.id}/domain`, {
                params: { minimal: 1 }
            })
            .then(res => {
                setDomains(res.data || [])
            })
            .catch(err => console.error(err))
    }, [organization.id])

    const domainOptions = domains.map(domain => ({
        value: domain.id,
        label: domain.name
    }))

    const onSubmit = values => {
        axios
            .put(
                `/organization/${organization.id}/system/banner-status/${id}`,
                values
            )
            .then(res => {
                if (res.status === 200) {
                     window.location = '/banner-status?message=Banner status updated successfully!'
                    // dispatch(
                    //     sendFlashMessage(
                    //         'Banner status updated successfully',
                    //         'alert-success'
                    //     )
                    // )
                    // //history.goBack()
                }
            })
            .catch(error => {
                dispatch(
                    sendFlashMessage(
                        <ApiErrorMessage errors={error.response?.data} />,
                        'alert-danger'
                    )
                )
            })
    }

    const onClickCancel = () => history.goBack()

    if (loading || !initialValues) return <p>Loading...</p>

    return (
        <Form key={initialValues?.id} onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit, pristine, submitting }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <Row className="w100">
                        <Col md="6">
                            <h3 className="mb-4">Edit Banner</h3>
                        </Col>
                        <Col md="6" className="text-right">
                            <ButtonToolbar>
                                <Button outline color="primary" onClick={onClickCancel}>
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={pristine || submitting}
                                >
                                    Save
                                </Button>
                            </ButtonToolbar>
                        </Col>
                    </Row>

                    {/* -------- Domain -------- */}
                    <Row>
                        <Col md="6">
                            <Field name="domain_id">
                                {({ input, meta }) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Domain</span>
                                        <Select
                                            options={domainOptions}
                                            isSearchable
                                            isClearable
                                            placeholder="Search domain..."
                                            value={
                                                domainOptions.find(
                                                    option => option.value === input.value
                                                ) || null
                                            }
                                            onChange={option =>
                                                input.onChange(option ? option.value : null)
                                            }
                                            onBlur={input.onBlur}
                                        />
                                        {meta.touched && meta.error && (
                                            <span className="form__form-group-error">
                                                {meta.error}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </Field>
                        </Col>
                    </Row>

                    {/* -------- Banner Status -------- */}
                    <Row>
                        <Col md="12">
                            <Field name="banner_status">
                                {({ input, meta }) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">
                                            Banner Status
                                        </span>
                                        <WYSIWYGEditor
                                            value={input.value}
                                            onChange={input.onChange}
                                        />
                                        {meta.touched && meta.error && (
                                            <span className="form__form-group-error">
                                                {meta.error}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </Field>
                        </Col>
                    </Row>
                </form>
            )}
        </Form>
    )
}

export default EditBannerStatusPage